/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_DiscrepanciesInputs */

const en_audit_discrepancies = /** @type {(inputs: Audit_DiscrepanciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discrepancies`)
};

const es_audit_discrepancies = /** @type {(inputs: Audit_DiscrepanciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discrepancias`)
};

/**
* | output |
* | --- |
* | "Discrepancies" |
*
* @param {Audit_DiscrepanciesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_discrepancies = /** @type {((inputs?: Audit_DiscrepanciesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_DiscrepanciesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_discrepancies(inputs)
	return es_audit_discrepancies(inputs)
});